import { render, staticRenderFns } from "./rfq-prepared-approve.vue?vue&type=template&id=21825a8b"
import script from "./rfq-prepared-approve.vue?vue&type=script&lang=js"
export * from "./rfq-prepared-approve.vue?vue&type=script&lang=js"
import style0 from "./rfq-prepared-approve.vue?vue&type=style&index=0&id=21825a8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports